const isProd = true;
export const BASE_URL = isProd ? "https://hud.mvrc.co.in" : "https://6fqm9v96-8000.inc1.devtunnels.ms";
export const hudLoginApiUrl = `${BASE_URL}/api-token-auth/`;
export const hudMachinesApiCRUDUrl = `${BASE_URL}/hud/machines/`;
export const hudMedicineApiCRUDUrl = `${BASE_URL}/hud/medicine/`;
export const hudGetMedicineTabletsApiUrl = `${BASE_URL}/hud/medicines-tablets`;
export const hudGetMedicineOintmentsApiUrl = `${BASE_URL}/hud/medicines-ointments`;
export const hudPatientApiCRUDUrl = `${BASE_URL}/hud/patient/`;
// Ex: hud/patient/<patient-id>/history/
// Ex: hud/patient/<patient-id>/photos/
// Ex: hud/patient/<patient-id>/pdfs/
// Ex: hud/patient/<patient-id>/add-package/
// Ex: hud/patient/<patient-id>/update-package/<package-id>/
// Ex: hud/patient/<patient-id>/ointments/
// Ex: hud/patient/<patient-id>/tablets/
// Ex: hud/patient/<patient-id>/add-medicine/

export const hudPackageApiOldCRUDUrl = `${BASE_URL}/api/package/`;
export const hudPackageApiCRUDUrl = `${BASE_URL}/hud/package/`;
// Ex: `${BASE_URL}/hud/package/<Package-ID>/add-comment/`;
// Ex: `${BASE_URL}/hud/package/<Package-ID>/doses/`; // To GET Doses
// Ex: `${BASE_URL}/hud/package/<Package-ID>/dose/<dose-id>/`; // To PATCH & DELETE Dose
// Ex: `${BASE_URL}/hud/package/<Package-ID>/dose/<dose-id>/add-comment/`; // To ADD comment
// Ex: `${BASE_URL}/hud/package/<Package-ID>/add-dose/`; // To ADD Dose
export const hudDoctoViewPatchUrl = `${BASE_URL}/hud/doctor-view-storage-patch/`;
export const hudAddPatintPackageInvoiceUrl = `${BASE_URL}/hud/package-invoice/`;